function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { Button, HStack, Text } from 'native-base';
const IconButton = _ref => {
  let {
    Icon,
    title,
    variant = 'freedom',
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(Button, _extends({}, rest, {
    colorScheme: "primary",
    variant: variant,
    _text: {
      fontSize: 'lg',
      lineHeight: 'md'
    }
  }), /*#__PURE__*/React.createElement(HStack, {
    space: 3,
    flex: 1,
    justifyContent: "center",
    alignItems: "center"
  }, Icon ? Icon : null, /*#__PURE__*/React.createElement(Text, {
    fontSize: "lg",
    fontWeight: "medium",
    fontFamily: "body",
    lineHeight: "md",
    textTransform: "uppercase",
    color: variant === 'freedom' ? 'white.700' : 'blue.400',
    accessibilityLabel: title,
    testID: title
  }, title)));
};
export default IconButton;
//# sourceMappingURL=index.js.map